/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  CalvinUser,
  ChangeEmail,
  CustomPasswordReset,
  Login,
  PaginatedCalvinUserList,
  PasswordChange,
  PasswordResetConfirm,
  PatchedCalvinUser,
  PatchedChangeEmail,
  RestAuthDetail,
  Token,
} from '../models/index';
import {
  CalvinUserFromJSON,
  CalvinUserToJSON,
  ChangeEmailFromJSON,
  ChangeEmailToJSON,
  CustomPasswordResetFromJSON,
  CustomPasswordResetToJSON,
  LoginFromJSON,
  LoginToJSON,
  PaginatedCalvinUserListFromJSON,
  PaginatedCalvinUserListToJSON,
  PasswordChangeFromJSON,
  PasswordChangeToJSON,
  PasswordResetConfirmFromJSON,
  PasswordResetConfirmToJSON,
  PatchedCalvinUserFromJSON,
  PatchedCalvinUserToJSON,
  PatchedChangeEmailFromJSON,
  PatchedChangeEmailToJSON,
  RestAuthDetailFromJSON,
  RestAuthDetailToJSON,
  TokenFromJSON,
  TokenToJSON,
} from '../models/index';

export interface AccountsCalvinuserListRequest {
  page?: number;
}

export interface AccountsCalvinuserPartialUpdateRequest {
  patchedCalvinUser?: Omit<PatchedCalvinUser, 'id' | 'email'>;
}

export interface AccountsChangeemailPartialUpdateRequest {
  patchedChangeEmail?: PatchedChangeEmail;
}

export interface AccountsChangeemailUpdateRequest {
  changeEmail: ChangeEmail;
}

export interface AccountsLoginCreateRequest {
  login: Login;
}

export interface AccountsPasswordChangeCreateRequest {
  passwordChange: PasswordChange;
}

export interface AccountsPasswordResetConfirmCreateRequest {
  passwordResetConfirm: PasswordResetConfirm;
}

export interface AccountsPasswordResetCreateRequest {
  customPasswordReset: CustomPasswordReset;
}

/**
 *
 */
export class AccountsApi extends runtime.BaseAPI {
  /**
   */
  async accountsCalvinuserListRaw(
    requestParameters: AccountsCalvinuserListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedCalvinUserList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/accounts/calvinuser/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedCalvinUserListFromJSON(jsonValue));
  }

  /**
   */
  async accountsCalvinuserList(
    requestParameters: AccountsCalvinuserListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedCalvinUserList> {
    const response = await this.accountsCalvinuserListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async accountsCalvinuserPartialUpdateRaw(
    requestParameters: AccountsCalvinuserPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CalvinUser>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/accounts/calvinuser/`,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedCalvinUserToJSON(requestParameters['patchedCalvinUser']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CalvinUserFromJSON(jsonValue));
  }

  /**
   */
  async accountsCalvinuserPartialUpdate(
    requestParameters: AccountsCalvinuserPartialUpdateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CalvinUser> {
    const response = await this.accountsCalvinuserPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async accountsCalvinusersListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CalvinUser>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/accounts/calvinusers/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue.map(CalvinUserFromJSON));
  }

  /**
   */
  async accountsCalvinusersList(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CalvinUser>> {
    const response = await this.accountsCalvinusersListRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async accountsChangeemailPartialUpdateRaw(
    requestParameters: AccountsChangeemailPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ChangeEmail>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/accounts/changeemail/`,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedChangeEmailToJSON(requestParameters['patchedChangeEmail']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ChangeEmailFromJSON(jsonValue));
  }

  /**
   */
  async accountsChangeemailPartialUpdate(
    requestParameters: AccountsChangeemailPartialUpdateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ChangeEmail> {
    const response = await this.accountsChangeemailPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async accountsChangeemailUpdateRaw(
    requestParameters: AccountsChangeemailUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ChangeEmail>> {
    if (requestParameters['changeEmail'] == null) {
      throw new runtime.RequiredError(
        'changeEmail',
        'Required parameter "changeEmail" was null or undefined when calling accountsChangeemailUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/accounts/changeemail/`,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: ChangeEmailToJSON(requestParameters['changeEmail']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ChangeEmailFromJSON(jsonValue));
  }

  /**
   */
  async accountsChangeemailUpdate(
    requestParameters: AccountsChangeemailUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ChangeEmail> {
    const response = await this.accountsChangeemailUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework  Accept the following POST parameters: username, password Return the REST Framework Token Object\'s key.
   */
  async accountsLoginCreateRaw(
    requestParameters: AccountsLoginCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Token>> {
    if (requestParameters['login'] == null) {
      throw new runtime.RequiredError(
        'login',
        'Required parameter "login" was null or undefined when calling accountsLoginCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/accounts/login/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: LoginToJSON(requestParameters['login']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => TokenFromJSON(jsonValue));
  }

  /**
   * Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework  Accept the following POST parameters: username, password Return the REST Framework Token Object\'s key.
   */
  async accountsLoginCreate(
    requestParameters: AccountsLoginCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Token> {
    const response = await this.accountsLoginCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
   */
  async accountsLogoutCreateRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RestAuthDetail>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/accounts/logout/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RestAuthDetailFromJSON(jsonValue));
  }

  /**
   * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
   */
  async accountsLogoutCreate(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RestAuthDetail> {
    const response = await this.accountsLogoutCreateRaw(initOverrides);
    return await response.value();
  }

  /**
   * Calls Django Auth SetPasswordForm save method.  Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
   */
  async accountsPasswordChangeCreateRaw(
    requestParameters: AccountsPasswordChangeCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RestAuthDetail>> {
    if (requestParameters['passwordChange'] == null) {
      throw new runtime.RequiredError(
        'passwordChange',
        'Required parameter "passwordChange" was null or undefined when calling accountsPasswordChangeCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/accounts/password/change/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: PasswordChangeToJSON(requestParameters['passwordChange']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RestAuthDetailFromJSON(jsonValue));
  }

  /**
   * Calls Django Auth SetPasswordForm save method.  Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
   */
  async accountsPasswordChangeCreate(
    requestParameters: AccountsPasswordChangeCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RestAuthDetail> {
    const response = await this.accountsPasswordChangeCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Password reset e-mail link is confirmed, therefore this resets the user\'s password.  Accepts the following POST parameters: token, uid,     new_password1, new_password2 Returns the success/fail message.
   */
  async accountsPasswordResetConfirmCreateRaw(
    requestParameters: AccountsPasswordResetConfirmCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RestAuthDetail>> {
    if (requestParameters['passwordResetConfirm'] == null) {
      throw new runtime.RequiredError(
        'passwordResetConfirm',
        'Required parameter "passwordResetConfirm" was null or undefined when calling accountsPasswordResetConfirmCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/accounts/password/reset/confirm/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: PasswordResetConfirmToJSON(requestParameters['passwordResetConfirm']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RestAuthDetailFromJSON(jsonValue));
  }

  /**
   * Password reset e-mail link is confirmed, therefore this resets the user\'s password.  Accepts the following POST parameters: token, uid,     new_password1, new_password2 Returns the success/fail message.
   */
  async accountsPasswordResetConfirmCreate(
    requestParameters: AccountsPasswordResetConfirmCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RestAuthDetail> {
    const response = await this.accountsPasswordResetConfirmCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Calls Django Auth PasswordResetForm save method.  Accepts the following POST parameters: email Returns the success/fail message.
   */
  async accountsPasswordResetCreateRaw(
    requestParameters: AccountsPasswordResetCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RestAuthDetail>> {
    if (requestParameters['customPasswordReset'] == null) {
      throw new runtime.RequiredError(
        'customPasswordReset',
        'Required parameter "customPasswordReset" was null or undefined when calling accountsPasswordResetCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/accounts/password/reset/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CustomPasswordResetToJSON(requestParameters['customPasswordReset']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RestAuthDetailFromJSON(jsonValue));
  }

  /**
   * Calls Django Auth PasswordResetForm save method.  Accepts the following POST parameters: email Returns the success/fail message.
   */
  async accountsPasswordResetCreate(
    requestParameters: AccountsPasswordResetCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RestAuthDetail> {
    const response = await this.accountsPasswordResetCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async accountsWhoamiRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/accounts/whoami/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async accountsWhoamiRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
    await this.accountsWhoamiRetrieveRaw(initOverrides);
  }
}
